<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="出质信息" name="1">
      <van-cell-group><van-field label="质权登记编号" :value="data.registNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="出质股权数额（万元）" :value="data.pledgedAmount" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="股权出质登记日期" :value="data.regDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="出质状态" :value="data.status" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="出质人信息" name="2">
      <!-- <van-cell-group><van-field label="KeyNo" :value="data.pledgorInfo.keyNo" placeholder="无" readonly /></van-cell-group> -->
      <van-cell-group><van-field label="证件号" :value="data.pledgorInfo.no" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="名称" :value="data.pledgorInfo.name" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="质权人信息" name="3">
      <!-- <van-cell-group><van-field label="KeyNo" :value="data.pledgeeInfo.keyNo" placeholder="无" readonly /></van-cell-group> -->
      <van-cell-group><van-field label="证件号" :value="data.pledgeeInfo.no" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="名称" :value="data.pledgeeInfo.name" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="出质股权标的企业" name="4">
      <!-- <van-cell-group><van-field label="KeyNo" :value="data.relatedCompanyInfo.keyNo" placeholder="无" readonly /></van-cell-group> -->
      <van-cell-group><van-field label="名称" :value="data.relatedCompanyInfo.name" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "equityPledgedCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>